import api from '../apis/api'
import { tokenConfig, tokenConfigUpload } from '../config'

export const UploadImageAPI = (type, body, query, state) => {
  return new Promise((res, rej) => {
    api.post(`/upload?${query}`, body, tokenConfigUpload(state))
      .then(resp => res(resp))
      .catch(err => rej(err?.response?.data?.error?.message || 'Error, Please try again later'))
  })
}